<template>
  <div>
<b-container class="side-n"  >

  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('saubhagya')" block squared id="bsaubhagya" class="btn-color btn-color-active">
        SAUBHAGYA
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('ipds')" block squared id="bipds" class=" btn-color">
    IPDS
  </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button  @click="goto('ddugjy')" block squared id="bddugjy" class=" btn-color">
      DDUGJY</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('uday')" block squared id="buday" class=" btn-color">
      UDAY</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('akashdeep')" block squared id="bakashdeep" class=" btn-color">
      AKASHDEEP</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col >
    <a href="http://www.rodalee.com/" target="_blank">
      <b-button @click="goto('rooftop')" block squared id="brooftop" class=" btn-color">
      Roof-Top Solar Project</b-button>
    </a>
  </b-col>
  </b-row>
</b-container>

</div>
</template>
<script>
//alert(myprop);
export default
 {
   mounted()
   {
     this.goto(this.$route.query.showdiv);
   },
  methods: {
  goto(refName) {
     var element=document.getElementById(refName);
     var btn_id='b' + refName;
     var btn=document.getElementById(btn_id);
     element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start'  });
     document.querySelector(".btn-color-active").classList.remove("btn-color-active");
     btn.classList.add("btn-color-active");
   }
  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;
 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd;
  border-color: #0277bd;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1;
  border-color: #0288d1;
  box-shadow:none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}

</style>
